import React from "react";
import { Text, Flex, Authenticator, Tabs } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";

import { PageIndex, PageTitle } from "../util/SEO";
import SearchableQuizCollection from "../features/quiz/components/Discovery/SearchableQuizCollection";
import fetchPaginatedListUsersQuizzes from "../features/quiz/utils/fetchPaginatedListUsersQuizzes";
import fetchPaginatedSearchUsersQuizzes from "../features/quiz/utils/fetchPaginatedSearchUsersQuizzes";
import LibraryQuizCard from "../features/quiz/components/Library/LibraryQuizCard";
import LessonCollection from "../features/quiz/components/Discovery/LessonCollection";
import { queryLessons } from "../features/lesson/services/queryLessons";
import { querySearchUsersLessons } from "../features/lesson/services/querySearchUsersLessons";

import { DocumentCollection } from "../features/quiz/components/Library/DocumentCollection";
import WinPremiumButton from "../features/referrals/components/WinPremiumButton";

export default function Library() {
  const navigate = useNavigate();

  PageTitle("Library | Gibbly");
  PageIndex("noindex");

  return (
    <>
      <Authenticator>
        <Flex direction={"column"} padding={"medium"} paddingTop={"large"}>
          <Flex justifyContent={"space-between"}>
            <Text id="pageTitle">My Library</Text>

            <Flex alignItems={"flex-end"}>
              <WinPremiumButton />
            </Flex>
          </Flex>

          <Tabs.Container defaultValue="quizzes">
            <Tabs.List>
              <Tabs.Item value={"quizzes"} fontSize={"small"}>
                Quizzes
              </Tabs.Item>
              <Tabs.Item value={"lessons"} fontSize={"small"}>
                Lessons
              </Tabs.Item>
              <Tabs.Item value={"document"} fontSize={"small"}>
                Documents
              </Tabs.Item>
            </Tabs.List>
            <Tabs.Panel value={"quizzes"} fontSize={"small"}>
              <SearchableQuizCollection
                collectionType="library-dashboard"
                queryKey="Library Quiz Ids"
                CardComponent={LibraryQuizCard}
                cardFunctionalProps={{
                  width: {},
                  hasButtons: true,
                  onClick: (quizId) => navigate(`/quiz/${quizId}`),
                }}
                fetchPaginatedList={(pageParam) =>
                  fetchPaginatedListUsersQuizzes(pageParam)
                }
                fetchPaginatedSearch={(search, pageParam) =>
                  fetchPaginatedSearchUsersQuizzes(search, pageParam)
                }
                templateColumns={{
                  base: "100%",
                  small: "minmax(0,1fr) minmax(0,1fr) ",
                  medium: "minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)",
                  large:
                    "minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)",
                  xl: "minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)",
                }}
              />
            </Tabs.Panel>
            <Tabs.Panel value={"lessons"} fontSize={"small"}>
              <LessonCollection
                collectionType="library-dashboard"
                listFunction={async () => {
                  const lessons = await queryLessons();
                  const sortedLessons = lessons.sort((a, b) => {
                    if (a.createdAt > b.createdAt) return -1;
                    if (a.createdAt < b.createdAt) return 1;
                    return 0;
                  });
                  return sortedLessons;
                }}
                searchFunction={async (search) => {
                  const lessons = await querySearchUsersLessons(search);
                  const sortedLessons = lessons.sort((a, b) => {
                    if (a.createdAt > b.createdAt) return -1;
                    if (a.createdAt < b.createdAt) return 1;
                    return 0;
                  });
                  return sortedLessons;
                }}
              />
            </Tabs.Panel>
            <Tabs.Panel value={"document"} fontSize={"small"}>
              <DocumentCollection />
            </Tabs.Panel>
          </Tabs.Container>
        </Flex>
      </Authenticator>
    </>
  );
}
